<ng-template
  #textInputTemplate
  let-item="item"
  let-group="group"
  let-jsonPath="jsonPath"
>
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="p-float-label">
      <!-- TODO: Remove pValidateOnly attribute once primeNg fixes regex validator -->
      <input
        type="text"
        class="w-full"
        pInputText
        [id]="jsonPath || item.jsonPath"
        [name]="jsonPath || item.jsonPath"
        [viaCapitalize]="item.capitalize"
        [viaTrim]="item.trim"
        [maxlength]="item.maxLength || ''"
        [minlength]="item.minLength || ''"
        [pTooltip]="item.tooltip"
        [tooltipPosition]="item.tooltipPosition || 'top'"
        [tooltipEvent]="item.tooltipEvent || 'hover'"
        [pKeyFilter]="item.regex"
        [pValidateOnly]="isRegexValidatedField(item)"
        [formControlName]="jsonPath || item.jsonPath"
        [attr.formControlName]="jsonPath || item.jsonPath"
      />
      <label [for]="jsonPath || item.jsonPath" class="text-muted mb-1">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
    </span>
  </div>
</ng-template>

<ng-template #currencyInputTemplate let-item="item" let-group="group">
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="p-float-label">
      <p-inputNumber
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
        [id]="item.jsonPath"
        [name]="item.jsonPath"
        mode="currency"
        currency="USD"
        locale="en-US"
        [min]="0"
        [maxFractionDigits]="2"
        class="w-full"
      ></p-inputNumber>
      <label [for]="item.jsonPath" class="text-muted mb-1">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
    </span>
  </div>
</ng-template>

<ng-template #percentInputTemplate let-item="item" let-group="group">
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="p-float-label">
      <p-inputNumber
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
        [id]="item.jsonPath"
        [name]="item.jsonPath"
        mode="decimal"
        prefix="% "
        locale="en-US"
        [min]="0"
        [max]="1000"
        [step]="0.01"
        [maxFractionDigits]="4"
        [minFractionDigits]="0"
        class="w-full"
      ></p-inputNumber>
      <label [for]="item.jsonPath" class="text-muted mb-1">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
    </span>
  </div>
</ng-template>

<ng-template #decimalInputTemplate let-item="item" let-group="group">
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="p-float-label">
      <p-inputNumber
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
        [id]="item.jsonPath"
        [name]="item.jsonPath"
        mode="decimal"
        locale="en-US"
        [maxFractionDigits]="2"
        class="w-full"
      ></p-inputNumber>
      <label [for]="item.jsonPath" class="text-muted mb-1">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
    </span>
  </div>
</ng-template>

<ng-template #intInputTemplate let-item="item" let-group="group">
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="p-float-label">
      <p-inputNumber
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
        [id]="item.jsonPath"
        [name]="item.jsonPath"
      ></p-inputNumber>
      <label [for]="item.jsonPath" class="text-muted mb-1">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
    </span>
  </div>
</ng-template>

<ng-template #textareaInputTemplate let-item="item" let-group="group">
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="p-float-label">
      <textarea
        [id]="item.jsonPath"
        class="w-full"
        pInputTextarea
        [name]="item.jsonPath"
        [rows]="3"
        [cols]="30"
        [autoResize]="true"
        [viaCapitalize]="item.capitalize"
        [viaTrim]="item.trim"
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
      ></textarea>
      <label [for]="item.jsonPath" class="text-muted mb-1">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
    </span>
  </div>
</ng-template>

<ng-template #selectInputTemplate let-item="item" let-group="group">
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="p-float-label">
      <p-dropdown
        *ngIf="item.inputType === 'select' && item.optionValue"
        [id]="item.jsonPath"
        [dataKey]="item.optionLabel"
        [options]="getDropdownOptions(item)()"
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
        [optionLabel]="item.optionLabel"
        [optionValue]="item.optionValue"
        [showClear]="true"
        [autoDisplayFirst]="false"
        placeholder="--Select--"
      >
        <ng-template let-option pTemplate="item">
          <div class="flex align-items-center gap-2">
            {{ item.optionLabel ? option[item.optionLabel] : option }}
          </div>
        </ng-template>
      </p-dropdown>
      <p-dropdown
        *ngIf="item.inputType === 'select' && !item.optionValue"
        [id]="item.jsonPath"
        [dataKey]="item.optionLabel"
        [options]="getDropdownOptions(item)()"
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
        [optionLabel]="item.optionLabel"
        [showClear]="true"
        [autoDisplayFirst]="false"
        placeholder="--Select--"
        [ngClass]="{ 'step-status': item.key === 'StepStatus' }"
      >
        <ng-template let-option pTemplate="item">
          <div
            class="flex align-items-center gap-2"
            [attr.trigger]="item.key === 'StepStatus' && option.isTrigger"
          >
            {{ item.optionLabel && option[item.optionLabel] }}
          </div>
        </ng-template>
      </p-dropdown>
      <label [for]="item.jsonPath" class="text-muted mb-1">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
    </span>
  </div>
</ng-template>

<ng-template #multiSelectInputTemplate let-item="item" let-group="group">
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="p-float-label">
      <!-- TODO: Need to identify how to store value for multi select. removing optionValue for now -->
      <p-multiSelect
        *ngIf="item.inputType === 'multi-select' && item.optionValue"
        [id]="item.jsonPath"
        [dataKey]="item.optionLabel"
        [options]="getDropdownOptions(item)()"
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
        [optionLabel]="item.optionLabel"
        [optionValue]="item.optionValue"
        [showClear]="true"
        placeholder="--Select--"
        selectedItemsLabel="{0} items selected"
      >
        <ng-template let-option pTemplate="item">
          <div class="flex align-items-center gap-2">
            {{ item.optionLabel ? option[item.optionLabel] : option }}
          </div>
        </ng-template>
      </p-multiSelect>
      <p-multiSelect
        *ngIf="item.inputType === 'multi-select' && !item.optionValue"
        [id]="item.jsonPath"
        [dataKey]="item.optionLabel"
        [options]="getDropdownOptions(item)()"
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
        [optionLabel]="item.optionLabel"
        [showClear]="true"
        placeholder="--Select--"
        selectedItemsLabel="{0} items selected"
      >
        <ng-template let-option pTemplate="item">
          <div class="flex align-items-center gap-2">
            {{ item.optionLabel ? option[item.optionLabel] : option }}
          </div>
        </ng-template>
      </p-multiSelect>
      <label [for]="item.jsonPath" class="text-muted mb-1">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
    </span>
  </div>
</ng-template>

<ng-template #dateInputTemplate let-item="item" let-group="group">
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="p-float-label">
      <p-calendar
        [id]="item.jsonPath"
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
        dateFormat="mm/dd/yy"
        [minDate]="item.minVal ? parseDate(item.minVal) : null"
        [maxDate]="item.maxVal ? parseDate(item.maxVal) : null"
      ></p-calendar>
      <label [for]="item.jsonPath" class="text-muted mb-1">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
    </span>
  </div>
</ng-template>

<ng-template #timeInputTemplate let-item="item" let-group="group">
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="p-float-label">
      <p-calendar
        [id]="item.jsonPath"
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
        [timeOnly]="true"
        hourFormat="12"
      ></p-calendar>
      <label [for]="item.jsonPath" class="text-muted mb-1">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
    </span>
  </div>
</ng-template>

<ng-template #switchInputTemplate let-item="item" let-group="group">
  <div [formGroup]="group" [ngClass]="['field', 'col-3', item.className || '']">
    <span class="flex align-items-center gap-2">
      <label [for]="item.jsonPath" class="text-muted">
        {{ item.label | pascalToSpace }}
        <span class="required-txt" *ngIf="!!item.required">*</span>
      </label>
      <p-inputSwitch
        [id]="item.jsonPath"
        [formControlName]="item.jsonPath"
        [attr.formControlName]="item.jsonPath"
      ></p-inputSwitch>
    </span>
  </div>
</ng-template>

<ng-template #arrayInputTemplate let-item="item" let-group="group">
  <div class="col-12 mb-2">
    <p-accordion [multiple]="true">
      @if (!getArrayControls(group, item.jsonPath).length) {
        <p-button
          [label]="'Add ' + item.label"
          [outlined]="true"
          (onClick)="addArrayItem(group, item, 0, $event)"
        ></p-button>
      }
      @for (formGroup of getArrayControls(group, item.jsonPath); track $index) {
        <p-accordionTab [selected]="true">
          <ng-template pTemplate="header">
            <div class="flex justify-content-center align-items-center gap-2">
              <span>{{ item.label }} {{ $index + 1 }}</span>
              <p-button
                icon="pi pi-plus"
                [rounded]="true"
                [outlined]="true"
                (onClick)="addArrayItem(group, item, $index, $event)"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                [rounded]="true"
                [outlined]="true"
                severity="danger"
                (onClick)="removeArrayItem(group, item, $index, $event)"
              ></p-button>
            </div>
          </ng-template>
          <ng-container
            *ngTemplateOutlet="
              formGroupTemplate;
              context: {
                group: formGroup,
                fields: item.items.properties,
              }
            "
          ></ng-container>
        </p-accordionTab>
      }
    </p-accordion>
  </div>
</ng-template>

<ng-template #primitiveArrayInputTemplate let-item="item" let-group="group">
  <div class="col-12 mb-2">
    <!-- <p-accordion [multiple]="true">
      @for (
        control of getArrayControls(group, item.jsonPath);
        track $index
      ) {
        <p-accordionTab [selected]="true">
          <ng-template pTemplate="header">
            <div class="flex justify-content-center align-items-center gap-2">
              <span>{{ item.label }} {{ $index + 1 }}</span>
              <p-button
                icon="pi pi-plus"
                [rounded]="true"
                [outlined]="true"
                (onClick)="addArrayItem(group, item, $index, $event)"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                [rounded]="true"
                [outlined]="true"
                severity="danger"
              ></p-button>
            </div>
          </ng-template>
          <ng-container
            *ngTemplateOutlet="
              textInputTemplate;
              context: {
                item: item.items,
                group: getArrayControls(group, item.jsonPath),
                jsonPath: $index
              }
            "
          ></ng-container>
        </p-accordionTab>
      }
    </p-accordion> -->
  </div>
</ng-template>

<ng-template #formGroupTemplate let-group="group" let-fields="fields">
  <div [formGroup]="group" class="formgrid grid p-fluid">
    <ng-container *ngFor="let item of getSortedFields(fields)">
      <ng-container *ngIf="isFieldVisible(item)">
        <ng-container [ngSwitch]="item.inputType">
          @if (item.inputType === 'text') {
            <ng-container
              *ngTemplateOutlet="
                textInputTemplate;
                context: {
                  item,
                  group,
                }
              "
            ></ng-container>
          } @else if (item.inputType === 'number') {
            @if (item.dataFormat === 'currency') {
              <ng-container
                *ngTemplateOutlet="
                  currencyInputTemplate;
                  context: {
                    item,
                    group,
                  }
                "
              ></ng-container>
            } @else if (item.dataFormat === 'percent') {
              <ng-container
                *ngTemplateOutlet="
                  percentInputTemplate;
                  context: {
                    item,
                    group,
                  }
                "
              ></ng-container>
            } @else if (item.dataFormat === 'decimal') {
              <ng-container
                *ngTemplateOutlet="
                  decimalInputTemplate;
                  context: {
                    item,
                    group,
                  }
                "
              ></ng-container>
            } @else if (item.dataFormat === 'int') {
              <ng-container
                *ngTemplateOutlet="
                  intInputTemplate;
                  context: {
                    item,
                    group,
                  }
                "
              ></ng-container>
            }
          } @else if (item.inputType === 'textarea') {
            <ng-container
              *ngTemplateOutlet="
                textareaInputTemplate;
                context: {
                  item,
                  group,
                }
              "
            ></ng-container>
          } @else if (item.inputType === 'select') {
            <ng-container
              *ngTemplateOutlet="
                selectInputTemplate;
                context: {
                  item,
                  group,
                }
              "
            ></ng-container>
          } @else if (item.inputType === 'multi-select') {
            <ng-container
              *ngTemplateOutlet="
                multiSelectInputTemplate;
                context: {
                  item,
                  group,
                }
              "
            ></ng-container>
          } @else if (item.inputType === 'date') {
            <ng-container
              *ngTemplateOutlet="
                dateInputTemplate;
                context: {
                  item,
                  group,
                }
              "
            ></ng-container>
          } @else if (item.inputType === 'time') {
            <ng-container
              *ngTemplateOutlet="
                timeInputTemplate;
                context: {
                  item,
                  group,
                }
              "
            ></ng-container>
          } @else if (item.inputType === 'switch') {
            <ng-container
              *ngTemplateOutlet="
                switchInputTemplate;
                context: {
                  item,
                  group,
                }
              "
            ></ng-container>
          } @else if (item.inputType === 'array') {
            <ng-container
              *ngTemplateOutlet="
                arrayInputTemplate;
                context: {
                  item,
                  group,
                }
              "
            ></ng-container>
          } @else if (item.inputType === 'primitive-array') {
            <ng-container
              *ngTemplateOutlet="
                primitiveArrayInputTemplate;
                context: {
                  item,
                  group,
                }
              "
            ></ng-container>
          }
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-container
  *ngTemplateOutlet="
    formGroupTemplate;
    context: {
      group: form,
      fields: formFields,
    }
  "
></ng-container>

<div
  class="gap-3 grid grid-nogutter justify-content-end"
  *ngIf="formFields?.length"
>
  <p-button label="Cancel" [outlined]="true" (click)="onCancel()"></p-button>

  <p-button
    *ngIf="!viewOnly"
    [label]="submitButtonText"
    (click)="save()"
  ></p-button>
  <p-button
    *ngIf="!viewOnly"
    [label]="updateButtonText"
    (click)="save(true)"
  ></p-button>
</div>
